import {useFormik} from "formik";
import * as yup from "yup";

import {useTranslation} from "react-i18next";
import {parseISO, startOfDay} from "date-fns";


export const aspects = [
    "NORTH", "NORTH_EAST", "EAST", "SOUTH_EAST", "SOUTH", "SOUTH_WEST", "WEST", "NORTH_WEST"
]


const useStationForm = ({station, onSubmit}) => {
    const {t} = useTranslation(['validation']);

    const formik = useFormik({
        initialValues: {
            workgroupId: station?.workgroup?.id,
            code: station?.code ?? "",
            name: station?.name ?? "",
            type: station?.type ?? "MANUAL",
            visibility: station?.visibility ?? "PUBLIC",
            lat: station?.geom?.coordinates?.[1] ?? "",
            lng: station?.geom?.coordinates?.[0] ?? "",
            elevation: station?.elevation ?? "",
            locationName: station?.locationName ?? "",
            slope: station?.slope ?? "",
            aspect: station?.aspect ?? "",
            acceptMod1: station?.acceptMod1 ?? false,
            acceptMod23: station?.acceptMod23 ?? false,
            activatedAt: station?.activatedAt ? parseISO(station.activatedAt) : (station ? null : startOfDay(new Date())),
            deactivatedAt: station?.deactivatedAt ? parseISO(station.deactivatedAt) : null,
            visibilityState: station?.visibilityState ?? null,
            provinceId: station?.provinceId ?? null,
            municipalityId: station?.municipalityId ?? null,
            notes: station?.notes ?? '',
        },
        validationSchema: yup.object({
            workgroupId: yup.string().required(t('validation:required')),
            code: yup.string().required(t('validation:required')),
            name: yup.string().required(t('validation:required')),
            type: yup.string().required(t('validation:required')),
            lat: yup.string().required(t('validation:required')),
            lng: yup.string().required(t('validation:required')),
            locationName: yup.string().required(t('validation:required')),
            elevation: yup.number(),
            slope: yup.number(),
            aspect: yup.string().oneOf(aspects),
            acceptMod1: yup.boolean().required(t('validation:required')),
            acceptMod23: yup.boolean().required(t('validation:required')),
            activatedAt: yup.date().nullable(),
            deactivatedAt: yup.date()
                .nullable()
                .min(yup.ref('activatedAt'), t('validation:deactivatedBeforeActivated')),
            notes: yup.string(),
        }),
        onSubmit: async (values) => {
            const {lat, lng, ...rest} = values;
            const data = {
                ...rest,
                elevation: rest.elevation === "" ? null : rest.elevation,
                slope: rest.slope === "" ? null : rest.slope,
                aspect: rest.aspect === "" ? null : rest.aspect,
                geom: {
                    type: 'Point',
                    coordinates:  [lng, lat]
                }
            };
            await onSubmit(data);
            formik.resetForm({values});  // reset stationForm
        }
    })

    const handlePositionChange = (position) => {
        formik.setValues({
            ...formik.values,
            lat: position.lat,
            lng: position.lng
        })
    }

    return {formik, handlePositionChange}
}

export default useStationForm;